



import React, { useState, useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import axios from "axios";

const DashboardLayout = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [userRole, setUserRole] = useState(() =>
    sessionStorage.getItem("user_role")
  );
  const [loading, setLoading] = useState();
  const [gifLoaded, setGifLoaded] = useState(false);

  const [permissionset, setPermissions] = useState([]);
  const [permissionsLoading, setPermissionsLoading] = useState(true);
  const [permissionsError, setPermissionsError] = useState(null);

  const permissionSet = useMemo(() => new Set(permissionset), [permissionset]);


  /* ---------- Preload Loader GIF ---------- */
  useEffect(() => {
    const img = new Image();
    img.src = "/images/breath1.gif";
    img.onload = () => setGifLoaded(true);
  }, []);

  /* ---------- Fetch User Role ---------- */
  // useEffect(() => {
  //   const fetchUserRole = async () => {
  //     if (userRole) {
  //       setLoading(false);
  //       return;
  //     }
  //     try {
  //       const res = await axios.get("/api/payload/", {
  //         withCredentials: true,
  //         timeout: 3000,
  //       });
  //       const role = res.data?.payload?.role_id?.toString() || null;
  //       setUserRole(role);
  //       if (role) sessionStorage.setItem("user_role", role);
  //     } catch (err) {
  //       console.error("Failed to fetch user role:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchUserRole();
  // }, [userRole]);



  // useEffect(() => {
  //   const fetchPermissions = async () => {
  //     try {
  //       setPermissionsLoading(true);
  //       setPermissionsError(null);

  //       const res = await axios.get("/api/user-roles/", {
  //         withCredentials: true,
  //       });

  //       const ids = (res.data?.content || []).map(item =>
  //         Number(item.id)
  //       );

  //       setPermissions(ids);
  //     } catch (err) {
  //       console.error("Failed to load permissions", err);
  //       setPermissionsError(true);
  //     } finally {
  //       setPermissionsLoading(false);
  //     }
  //   };

  //   fetchPermissions();
  // }, []);

  useEffect(() => {
    let isActive = true;

    const fetchPermissions = async () => {
      try {
        setPermissionsLoading(true);
        setPermissionsError(null);

        const res = await axios.get(
          "/sso/permissions/",
          {
            withCredentials: true,
          }
        );

        if (!isActive) return;
        setPermissions(res.data.permission_ids);

      } catch (err) {
        if (!isActive) return;
        console.error("Failed to load permissions", err);
        setPermissionsError(true);
      } finally {
        if (isActive) {
          setPermissionsLoading(false);
        }
      }
    };

    fetchPermissions();

    return () => {
      isActive = false;
    };
  }, []);

  console.log(permissionset, "gggggggggggggggggggggggg");


  /* ---------- Responsive Sidebar ---------- */
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      setSidebarOpen(!mobile);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  /* ---------- Loader ---------- */
  if (loading || !gifLoaded) {
    return (
      <div
        style={{
          display: "flex",
          minHeight: "100vh",
          justifyContent: "center",
          alignItems: "center",
          background: "#f8fafc",
        }}
      >
        <img
          src="/images/breath1.gif"
          alt="Loading"
          style={{ width: 350, height: 350 }}
        />
      </div>
    );
  }

  // const shouldShowSidebar =
  //   location.pathname !== "/managers/dashboard" &&
  //   location.pathname !== "/hr/dashboard";

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar
        userRole={userRole}
        permission={permissionset}
        loading={permissionsLoading}
        error={permissionsError}
        isOpen={sidebarOpen}
        toggleSidebar={() => setSidebarOpen((p) => !p)}
        onMouseEnter={() => !isMobile && setSidebarOpen(true)}
        onMouseLeave={() => !isMobile && setSidebarOpen(false)}
      />

      <div
        style={{
          flex: 1,
          marginLeft:
            isMobile
              ? "0"
              : sidebarOpen
                ? "230px"
                : "70px",
          transition: "margin-left 0.3s ease",
          width: "100%",
        }}
      >
        <Outlet context={{ permissionSet, permissionset, permissionsLoading, permissionsError }} />
      </div>
    </div>
  );
};

export default DashboardLayout;




